import React, { useCallback } from 'react';
import { Flex, LayoutGrid, LayoutGridItem, PrimaryButton, TextHeadingTwo } from '@cko/primitives';

import { useIsBlockedHelper } from '@cko/dashboard-shared';
import { AccountLevel } from '../../config/shared/enums/accountLevels';
import { AlertIcon, IconBox } from './BlockedPage.styles';

export const BLOCKED_PAGE_TEST_IDS = {
  changeViewButton: 'test-change-view-button',
  wrapper: 'test-blocked-modal-wrapper',
};

type Props = {
  requiredAccountLevels: Array<AccountLevel>;
};

export const BlockedPage = ({ requiredAccountLevels }: Props) => {
  const { requiredAccountLevelName, switchToRequiredAccountLevel, switchViewText } =
    useIsBlockedHelper(requiredAccountLevels);

  const switchView = useCallback(() => {
    if (switchToRequiredAccountLevel) {
      switchToRequiredAccountLevel();
    }
  }, [switchToRequiredAccountLevel]);

  return (
    <LayoutGrid data-testid={BLOCKED_PAGE_TEST_IDS.wrapper} paddingTop="var(--layout-saxophone)">
      <LayoutGridItem span={24}>
        <Flex alignItems="center" flexDirection="column">
          <IconBox>
            <AlertIcon />
          </IconBox>
          <TextHeadingTwo marginBottom="var(--layout-shoe)">{switchViewText}</TextHeadingTwo>
          {requiredAccountLevelName && (
            <PrimaryButton
              data-testid={BLOCKED_PAGE_TEST_IDS.changeViewButton}
              onClick={switchView}
            >
              Switch view
            </PrimaryButton>
          )}
        </Flex>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
